import { action, withPayload } from '../../../utility/redux';

export const setCurrentOrganizationTab = action(
  'SET_CURRENT_ORGANIZATION_TAB',
  withPayload<string>(),
);

export const setCurrentProjectTab = action(
  'SET_CURRENT_PROJECT_TAB',
  withPayload<string>(),
);

export const setCurrentProfileTab = action(
  'SET_CURRENT_PROFILE_TAB',
  withPayload<string>(),
);

export const setCurrentOwnOrganizationTab = action(
  'SET_CURRENT_OWN_ORGANIZATION_TAB',
  withPayload<string>(),
);

export const setCurrentVideoMenuTab = action(
  'SET_CURRENT_VIDEO_MENU_TAB',
  withPayload<string>(),
);

export const setCurrentUserTab = action(
  'SET_CURRENT_USER_MENU_TAB',
  withPayload<string>(),
);
